import React, {Component} from 'react';
import config from 'config';
import classnames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import {connect} from 'react-redux';
import { Icon } from 'antd';
import {fetchWechatArticle} from '../actions';
import { actions } from 'modules/modal';
const errorJpg = require('./images/error.jpg');
import clientId from 'clientId';
import './style.css';

const container = connect(
  (state) => ({
    layoutPicNews: _.get(state, 'me.permission.layout.picNews'),
    layoutPicWeChat: _.get(state, 'me.permission.layout.picWeChat'),
    data: _.get(state, 'carousel.data'),
    showTraditionalContent: _.get(state, 'me.permission.showTraditionalContent', false)
  })
)

class Carousel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    };
  }

  componentDidMount() {
    const {dispatch, layoutPicNews, layoutPicWeChat} = this.props;
    const _from = layoutPicWeChat || (window.location.host.split('.')[0] == "spop-umac" ? "澳大UM" : "澳门高等教育辅助办公室");
    const fetchQuery = layoutPicNews ? {
      subjectId: layoutPicNews,
      mediaType: 'news',
      limit: 5,
      hasImage: true
    }: {
      mediaType: 'wechat',
      from: _from,
      limit: 3,
      startDate: moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment().format('YYYY-MM-DD HH:mm:ss')
    }
    dispatch(fetchWechatArticle(fetchQuery));
    this.interval = setInterval(() => {
      const {data} = this.props;
      if (_.isEmpty(data)) {
        return;
      }
      const selected = this.state.index;
      const index = (selected + 1) % data.length;
      this.handleSwitch(index);
    }, 10000);
  }

  handleLoadedImage(index) {
    const dom = this.refs[`img${index}`];
    dom.style.top = `${(285 - dom.height) / 2}px`;
  }

  handleError(index) {
    const dom = this.refs[`img${index}`];
    dom.src = errorJpg;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleSwitch(index) {
    this.setState({
      index: index,
    });
  }

  render() {
    const {data} = this.props;
    const _index = this.state.index;


    const pictures = _.map(data, (item, index) => {
      return (
        <div ref="pictures"
          key={index}
          className={classnames('carousel-picture-item', {active: _index === index})}
        >
          <img
            alt="由於原圖下載出現錯誤，未能正確顯示，請到相關微信公眾號查閱。"
            src={_.get(item, 'mediaType') == 'news' ? _.get(item, 'images[0]') : `${config.microdata.baseUrl}/imgserve?_url=${_.get(item, 'images[0]')}`}
            className="picture"
            onLoad={() => this.handleLoadedImage(index)}
            onError={() => this.handleError(index)}
            ref={`img${index}`}
          />
        </div>
        );
    });

    const infos = _.map(data, (item, index) => {
      return (
        <div key={index} className={classnames('carousel-info-item', {show: _index === index})}>
          <a
            className="info-title"
            onClick={() => {
              const {dispatch, showTraditionalContent} = this.props;
              if ((!showTraditionalContent && _.get(item, 'isTraditional', false)) || item.mediaType == 'news') {
                dispatch(actions.setIsRead(item));
                window.open(item.url);
              } else {
                dispatch(actions.toggleArticleModal(item));
              }
            }}
          >
            {item.title}
          </a>
          <div className="info-content">{item && item.conten_summary}...</div>
          <div className="info-date">
            <Icon type="calendar" className="margin-right-md"/>
            <span>{moment(item.date).format('YYYY-MM-DD HH:mm')}</span>
          </div>
        </div>
        );
    });

    const buttons = _.map(data, (item, index) => {
      return (
        <div key={index} className={classnames('carousel-button-item', {active: _index === index})} onClick={() => this.handleSwitch(index)}></div>
        );
    });

    return (
      <div className="carousel-container">
        <div className="carousel-picture">
          {pictures}
        </div>
        <div className="carousel-info">
          {infos}
        </div>
        <div className="carousel-button">
          {buttons}
        </div>
      </div>
    )
  }
}

export default container(Carousel)



/** WEBPACK FOOTER **
 ** ./src/app/modules/carousel/components/Carousel.js
 **/